export default __webpack_public_path__ + "static/4-4903e5871e71b66012b040cc75d7eef7.jpg";